export default __webpack_public_path__ + "logo0279c4ce.png";